import { render, staticRenderFns } from "./blog-3.vue?vue&type=template&id=4fe85616&"
import script from "./blog-3.vue?vue&type=script&lang=js&"
export * from "./blog-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports